import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@knockrentals/knock-shared-web-v2';
import { formatMaxIncome, parseMaxIncome } from './utils';

export const MAX_INCOME_ARIA_LABEL = 'maximum income';

const MaxIncome = ({
  clearValidationErrorMessage,
  errorMessage,
  maxIncome,
  maxIncomeOnChange,
}) => {
  const [cursorPosition, setCursorPosition] = useState({
    selectionEnd: null,
    selectionStart: null,
  });
  const [isEditing, setIsEditing] = useState(false);

  const incomeRef = useRef();

  const hasCursorPositionChanged =
    incomeRef.current &&
    cursorPosition.selectionEnd !== null &&
    cursorPosition.selectionStart !== null;

  useEffect(() => {
    if (hasCursorPositionChanged) {
      incomeRef.current.setSelectionRange(
        cursorPosition.selectionStart,
        cursorPosition.selectionEnd,
      );
    }

    setCursorPosition({ selectionEnd: null, selectionStart: null });
  }, [
    cursorPosition.selectionEnd,
    cursorPosition.selectionStart,
    hasCursorPositionChanged,
  ]);

  const handleOnBlur = () => {
    setIsEditing(false);
    setCursorPosition({ selectionEnd: null, selectionStart: null });
  };

  const handleOnChange = (_value, e) => {
    const { selectionEnd, selectionStart, value } = e.target;
    const parsed = parseMaxIncome(value);
    const offset = value.length - parsed.length;

    setCursorPosition({
      selectionEnd: selectionEnd - offset,
      selectionStart: selectionStart - offset,
    });

    maxIncomeOnChange(parsed);
  };

  const handleOnFocus = () => {
    setIsEditing(true);

    if (errorMessage) {
      clearValidationErrorMessage();
    }
  };

  return (
    <TextField
      aria-label={MAX_INCOME_ARIA_LABEL}
      error={Boolean(errorMessage)}
      fullWidth
      helperText={errorMessage}
      inputRef={incomeRef}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      startIcon={isEditing ? '' : 'currency-dollar'}
      value={isEditing ? maxIncome : formatMaxIncome(maxIncome)}
      variant="outlined"
    />
  );
};

MaxIncome.propTypes = {
  clearValidationErrorMessage: PropTypes.func,
  errorMessage: PropTypes.string,
  maxIncome: PropTypes.string,
  maxIncomeOnChange: PropTypes.func,
};

export default MaxIncome;
